export const windowWidth = 528;
export const glowWidthOffset = 60;
export const glowXOffset = 18;
